import { render, staticRenderFns } from "./Faturas.vue?vue&type=template&id=cdd0dd6e&scoped=true"
import script from "./Faturas.vue?vue&type=script&lang=js"
export * from "./Faturas.vue?vue&type=script&lang=js"
import style0 from "./Faturas.vue?vue&type=style&index=0&id=cdd0dd6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd0dd6e",
  null
  
)

export default component.exports